// Tailwind classes per wine type for badges/labels used across catalog + detail pages.
const WINE_TYPE_BADGE_CLASSES = {
  white:     "bg-gold/10 text-gold border-gold/30",
  sparkling: "bg-gold-light/10 text-gold-light border-gold-light/30",
  rose:      "bg-pink-500/10 text-pink-400 border-pink-500/30",
  red:       "bg-merlot/20 text-merlot-light border-merlot/30",
};

export function getWineTypeBadgeClass(type) {
  return WINE_TYPE_BADGE_CLASSES[type] || WINE_TYPE_BADGE_CLASSES.red;
}
